import {DataGridPro, GridRowId, useGridApiRef} from '@mui/x-data-grid-pro'
import {envBackHost, envImagePath, serverLocalName} from 'GLOBAL/envVariables'
import {axiosWithAuth} from 'helper/axiosWithAuth'
import fileDownload from 'js-file-download'
import CustomerDetailInfoMdal from 'pages/common/CustomerDetailInfoMdal'
import CustomerHmdTargetImageListModal from 'pages/common/CustomerHmdTargetImageListModal'
import ExcelDownLoadModal from 'pages/common/ExcelDownloadModal'
import PhotoModal from 'pages/common/PhotoModal'
import {
  customerHmdColumns,
  customerStatusBoseongColumns,
} from 'pages/customer/dataConfig/declearColumns'
import {customerStatusFilter} from 'pages/customer/dataConfig/declearFilters'
import {
  CustomerBusanStatusGroup,
  CustomerHmdGroup,
} from 'pages/customer/dataConfig/declearGroupingModel'
import {customerHmdInfoRows} from 'pages/customer/dataConfig/declearRows'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {toast} from 'react-toastify'
import {getCustomerHdmList} from 'utils/apiCalling/api'
import {useServerCycleSetting} from 'utils/config/serverCycleConfig'
import {showBusanExcelHandler} from 'utils/const/globalController'
import {confirmPhotoAlert, resultAlert, warningPhotoAlert} from 'utils/CustomAlert/Alert'

import CustomPagination from 'utils/designSytem/CustomPagination'
import MeterariumPageLayout from 'utils/designSytem/MeterariumPageLayout'
import {
  customerDetailModalClose,
  customerDetailModalOpen,
  imageDetailModalClose,
  imageDetailModalOpen,
  onRowsSelectionHandler,
  photoModalClose,
  photoModalOpen,
  scrollTop,
} from 'utils/func/justUtils'
import {toolTipText} from 'utils/toolTips/toolTipText'

const CustomerHdm = () => {
  /*********************************************************************
   * 1. Init Libs
   *********************************************************************/
  const location = useLocation()
  const userInfo = useSelector((state: any) => state?.userInfo)
  const officeInfo = useSelector((state: any) => state?.officeInfo)
  /* 통신주기 필터 노출 여부는 사업소마다 다르다 (/dev/server-cycle-config 에서 관리) */
  const serverCycle = useServerCycleSetting(officeInfo?.value)
  const cooperInfo = useSelector((state: any) => state?.cooperInfo)
  const pageState = location?.state
  /*********************************************************************
   * 2. State settings
   *********************************************************************/
  const [deviceDetailData, setDeviceDetailData] = useState<any>()
  const [checkData, setCheckData] = useState<any>([])
  const [customerDetailData, setCustomerDetailData] = useState<any>(null)
  const [customerInfoList, setCustomerInfoList] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [totalCount, setTotalCount] = useState<any>(null)
  const [selectionModel, setSelectionModel] = useState<GridRowId[]>([])
  const [filter, setFilter] = useState<any>(customerStatusFilter(pageState))
  const [imageDetailOpen, setImageDetailOpen] = useState<boolean>(false)
  const [customerDetailOpen, setCustomerDetailOpen] = useState<boolean>(false)
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false)
  const [photoData, setPhotoData] = useState<any>({})
  const [photoModal, setPhotoModal] = useState<boolean>(false)
  const [targetRowId, setTargetRowId] = useState<any>(0)
  const [rows, setRows] = useState<any[]>([])
  const [downloadOpen, setDownloadOpen] = useState<boolean>(false)
  /*********************************************************************
   * 3. Handlers
   *********************************************************************/
  const openImageDetailModal = () => imageDetailModalOpen(setImageDetailOpen)
  const openCustomerDetailModal = () => customerDetailModalOpen(setCustomerDetailOpen)
  const closeImageDetailModal = () => imageDetailModalClose(setImageDetailOpen)
  const closeCustomerDetailModal = () => customerDetailModalClose(setCustomerDetailOpen)
  const closePhotoModal = () => photoModalClose(setPhotoModal)
  const openPhotoModal = () => photoModalOpen(setPhotoModal)

  const getphotoDownload = async (types: any) => {
    const customerNumberMap = checkData
      .filter((item: any) => item.existsInstallPhoto === true)
      .map((item: any) => item.customerNumber)
    const customerNumberList = customerNumberMap.join(',')

    const photoAlertTextHandler = (type: any, length: any) => {
      switch (type) {
        case 'excel':
          if (length > 50) {
            return '50개 이상 받으실 경우 Zip파일로 제공되며,<br/> 시간이 오래 걸릴 수 있습니다.'
          }
          return `선택한 수용가 중 사진첩이 있는 ${length}건이 엑셀 파일로 제공되며,<br/> 시간이 오래 걸릴 수 있습니다.`
        case 'pdf':
          return `선택한 수용가 중 사진첩이 있는 ${length}건이 PDF 파일로 제공되며,<br/> 시간이 오래 걸릴 수 있습니다.`
        default:
          return ''
      }
    }

    const isZip = customerNumberMap.length > 50 ? true : false

    const text = photoAlertTextHandler(types, customerNumberMap.length)

    if (customerNumberMap.length > 100) {
      await warningPhotoAlert()
      return false
    }

    switch (types) {
      case 'excel':
        if (await confirmPhotoAlert(text)) {
          await toast
            .promise(
              axiosWithAuth()
                .get(`${envBackHost}/customer/excel/photo/${officeInfo?.value}`, {
                  params: {customerNumbers: customerNumberList},
                  responseType: 'blob',
                })
                .then(async (res) => {
                  await resultAlert({resultCode: 0})
                  fileDownload(res.data, `${officeInfo?.label}_사진첩.${isZip ? 'zip' : 'xlsx'}`)
                })
                .catch(async (e) => {
                  await resultAlert({resultCode: 400})
                }),
              {
                pending: '다운로드 중입니다.',
              },
              {
                position: 'top-center',
                autoClose: 1000,
                className: 'fs-3  fw-bold',
                style: {width: '400px'},
              }
            )
            .catch(async (e) => {
              console.log(e)
              await resultAlert({resultCode: 400})
            })
        }
        break
      case 'pdf':
        if (await confirmPhotoAlert(text)) {
          await toast
            .promise(
              axiosWithAuth()
                .get(`${envBackHost}/customer/pdf/photo/${officeInfo?.value}`, {
                  params: {customerNumbers: customerNumberList},
                  responseType: 'blob',
                })
                .then(async (res) => {
                  await resultAlert({resultCode: 0})
                  fileDownload(res.data, `${officeInfo?.label}_사진첩.pdf`)
                })
                .catch(async (e) => {
                  await resultAlert({resultCode: 400})
                }),
              {
                pending: '다운로드 중입니다.',
              },
              {
                position: 'top-center',
                autoClose: 1000,
                className: 'fs-3  fw-bold',
                style: {width: '400px'},
              }
            )
            .catch(async (e) => {
              console.log(e)
              await resultAlert({resultCode: 400})
            })
        }
        break
      default:
        return null
    }
  }
  const apiRef = useGridApiRef()
  const getCustomerInfo = async () => {
    const handleResponse = async (res: any, count: any) => {
      const rows = customerHmdInfoRows(res).map((row: any) => ({
        ...row,
        imageWidth: null,
        imageHeight: null,
      }))

      setCustomerInfoList(res)
      setRows(rows)
      setTotalCount(count)

      rows.forEach((row: any) => {
        if (row.filePath) {
          const img = new Image()
          img.src = envImagePath + row.filePath

          img.onload = () => {
            setRows((prev) =>
              prev.map((r) =>
                r.id === row.id && !r.imageWidth
                  ? {...r, imageWidth: img.width, imageHeight: img.height}
                  : r
              )
            )
          }

          img.onerror = () => {
            setRows((prev) =>
              prev.map((r) =>
                r.id === row.id && !r.imageWidth ? {...r, imageWidth: null, imageHeight: null} : r
              )
            )
          }
        }
      })
    }

    const checkBusan = String(officeInfo.value).slice(0, 2) === '13'
    const hasAnyTrue = Object.values(filter.searchOption).some((v) => v === true)
    const newSearchOption =
      !filter.searchOption.customerNumber && hasAnyTrue
        ? {installer: false}
        : {customerNumber: true}
    let selectedFilter = filter
    if (checkBusan) {
      selectedFilter = {
        ...filter,
        searchOption: newSearchOption,
      }
    }
    if (checkBusan) {
      await getCustomerHdmList(
        officeInfo,
        cooperInfo,
        selectedFilter,
        (res: any, count: any) => {
          handleResponse(res, count)
        },
        (error: any) => {},
        () => {
          setLoading(loading)
        }
      )
    } else {
      await getCustomerHdmList(
        officeInfo,
        cooperInfo,
        selectedFilter,
        (res: any, count: any) => {
          handleResponse(res, count)
        },
        (error: any) => {},
        () => {
          setLoading(loading)
        }
      )
    }
  }

  const busanSearchHandler = (officeId: any) => {
    const checkBusan = String(officeId).slice(0, 2) === '13'
    return ['customerNumber', 'customerName', 'address', 'managerName']
  }

  const columnHandler = (serverName: string): any => {
    switch (serverName) {
      case 'boseong':
        return customerStatusBoseongColumns(
          openImageDetailModal,
          openCustomerDetailModal,
          setCustomerDetailData,
          setDeviceDetailData,
          cooperInfo,
          officeInfo,
          openPhotoModal,
          setPhotoData,
          setTargetRowId
        )
      default:
        return customerHmdColumns(
          openImageDetailModal,
          openCustomerDetailModal,
          setCustomerDetailData,
          setDeviceDetailData,
          cooperInfo,
          officeInfo,
          openPhotoModal,
          setPhotoData,
          setTargetRowId
        )
    }
  }

  const groupingModel = !showBusanExcelHandler(serverLocalName, officeInfo?.value)
    ? CustomerBusanStatusGroup
    : CustomerHmdGroup

  /*********************************************************************
   * 4. UseEffect
   *********************************************************************/
  useEffect(() => {
    scrollTop()
    getCustomerInfo()
  }, [
    filter?.efosStatus,
    filter?.deviceStatus,
    filter?.deviceType,
    filter?.batteryStatus,
    filter.rowPerPage,
    filter?.page,
    filter?.serverCycle,
    officeInfo,
    cooperInfo,
  ])

  useEffect(() => {
    setFilter(customerStatusFilter(pageState))
  }, [officeInfo?.value])
  /*********************************************************************
   * 5. Page configuration
   *********************************************************************/
  return (
    <>
      <MeterariumPageLayout
        headerDescription={toolTipText.customerhdm.description}
        tooltipText={toolTipText.customerhdm.text}
        hideSearchOptions={accordionOpen}
        setHideSearchOptions={setAccordionOpen}
        filter={filter}
        id={'customer-hdm'}
        setFilter={setFilter}
        searchCallback={getCustomerInfo}
        total={totalCount}
        control={[
          'device',
          // 'deviceType',
          // 'battery',
          ...(['B600', 'B6'].includes(officeInfo.value) ? ['uiseongDistrict'] : []),
          ...(serverCycle.pages.includes('hdm') ? ['serverCycle'] : []),
        ]}
        searchOptions={busanSearchHandler(officeInfo.value)}
        actions={[
          ...(['8401', '8400', '84'].includes(officeInfo?.value)
            ? [
                // 'photoDownload'
              ]
            : []),
        ]}
        checkData={null}
        asValue={{
          setCheckData,
        }}
        onDelete={null}
        onCancel={null}
        setTypeName={null}
        onDownloadOpen={() => setDownloadOpen(true)}
        downloadApi={(type: any) => getphotoDownload(type)}
      >
        <DataGridPro
          headerHeight={40}
          rowHeight={180}
          apiRef={apiRef}
          // getRowHeight={(params: any) => getRowHeightOnDataGrid(params)}
          autoHeight={true}
          columnGroupingModel={CustomerHmdGroup}
          experimentalFeatures={{columnGrouping: true}}
          rows={rows}
          rowCount={rows?.length}
          columns={columnHandler(serverLocalName)}
          disableColumnMenu
          loading={loading}
          // checkboxSelection
          // selectionModel={selectionModel}
          onSelectionModelChange={(ids, selection) => {
            const selectedRowsData = ids.map((id) => rows.find((row: any) => row.id === id))
            onRowsSelectionHandler(ids, [
              [setCheckData, selectedRowsData],
              [setSelectionModel, ids],
            ])
          }}
          paginationMode={'server'}
          hideFooterPagination={true}
          pagination={true}
          hideFooter={true}
          sx={{
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',
            },
          }}
        />
        <CustomPagination filter={filter} setFilter={setFilter} totalCount={totalCount} />
      </MeterariumPageLayout>

      <CustomerHmdTargetImageListModal
        data={deviceDetailData}
        open={imageDetailOpen}
        onClose={closeImageDetailModal}
      />
      <CustomerDetailInfoMdal
        data={customerDetailData}
        open={customerDetailOpen}
        onClose={closeCustomerDetailModal}
        getList={getCustomerInfo}
        page='status'
      />
      <PhotoModal
        setData={setPhotoData}
        data={photoData}
        open={photoModal}
        onClose={closePhotoModal}
        page='status'
        rowCount={targetRowId}
        filter={filter}
        pagenation={filter.page}
        perPage={filter.rowPerPage}
        getList={getCustomerInfo}
        count={totalCount}
      />

      <ExcelDownLoadModal
        type={'수용가 현황'}
        search={filter}
        open={downloadOpen}
        onClose={() => setDownloadOpen(false)}
      />
    </>
  )
}
export default CustomerHdm
